import React from 'react'
import { Dialog } from 'primereact/dialog';
import { Button, Spinner } from 'reactstrap';

export const DialogPreviewQuoterPdf = (props) => {

    const {

        pdfPreviewQuoter, showPreviewPdfQuoter, setShowPreviewPdfQuoter, loadingPdfQuoter, downloadQuoter,informationQuatation
  
      } = props;

  return (
    <Dialog
        header="Previsualización de Cotización"
        visible={showPreviewPdfQuoter}
        style={{ width: '60vw', maxWidth: '700px' }}
        modal
        dismissableMask  
        onHide={() => setShowPreviewPdfQuoter(false)}
        headerStyle={{
        backgroundColor: '#0d3b59',
        color: 'white',
        fontWeight: 'bold',
        }}
        pt={{
        header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
        headerIcon: { style: { color: 'white' } },
        }}
    >
    {pdfPreviewQuoter && (
        <>
            <iframe
                src={pdfPreviewQuoter}
                title="PDF Preview"
                width="100%"
                height="600px"
                style={{ border: "none" }}
            />
             <div style={{ marginTop: '10px', textAlign: 'center' }}>
                <Button
                    className="p-button-primary"
                    style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
                    onClick={() => downloadQuoter(informationQuatation[0].id_quoter)}
                    
                    disabled={loadingPdfQuoter}
                >
                    {loadingPdfQuoter && <Spinner size="sm" color="light" />} 
                    {loadingPdfQuoter ? "Generando PDF..." : "Descargar PDF"}
                </Button>

            </div>
        </>
        )}
    </Dialog>
   
  )
}
